"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarFactoryFromJS = exports.ToolbarFactory = void 0;
const toolbar_1 = require("../modules/toolbar");
const immutable_1 = require("immutable");
exports.ToolbarFactory = (0, immutable_1.Record)({
    items: (0, immutable_1.List)()
});
const ToolbarFactoryFromJS = function (data) {
    const items = data.items
        ? data.items.map(function (value) {
            return (0, toolbar_1.ToolbarItemFactoryFromJS)(value);
        })
        : [];
    return (0, exports.ToolbarFactory)({
        items: (0, immutable_1.List)(items)
    });
};
exports.ToolbarFactoryFromJS = ToolbarFactoryFromJS;
//# sourceMappingURL=IToolbar.js.map